import Base from './Base.vue'
import Edit from './Edit.vue'

export default {
    Base,
    Edit
}



// WEBPACK FOOTER //
// ./src/views/salesman/account/index.js